import {
  CellStyleModule,
  ClientSideRowModelModule,
  ColumnApiModule,
  ColumnAutoSizeModule,
  ColumnHoverModule,
  CustomEditorModule,
  DateEditorModule,
  DragAndDropModule,
  ExternalFilterModule,
  HighlightChangesModule,
  LargeTextEditorModule,
  MasterDetailModule,
  ModuleRegistry,
  NumberEditorModule,
  RenderApiModule,
  RowApiModule,
  RowAutoHeightModule,
  RowDragModule,
  RowStyleModule,
  TextEditorModule,
  TooltipModule,
} from 'ag-grid-enterprise';

type AGGridModule = Parameters<
  typeof ModuleRegistry.registerModules
>[0][number];

let crudModulesRegistered = false;
const registeredModules = new Set<AGGridModule>();

const crudAGGridModules: AGGridModule[] = [
  ColumnAutoSizeModule,
  ColumnHoverModule,
  RowAutoHeightModule,
  RowStyleModule,
  RowDragModule,
  CellStyleModule,
  HighlightChangesModule,
  TooltipModule,
  TextEditorModule,
  LargeTextEditorModule,
  NumberEditorModule,
  CustomEditorModule,
  DragAndDropModule,
  ClientSideRowModelModule,
  MasterDetailModule,
  ExternalFilterModule,
  RenderApiModule,
  ColumnApiModule,
  RowApiModule,
  DateEditorModule,
];

type RegisterCRUDAGGridModulesArgs = {
  additionalModules?: AGGridModule[];
};

export function registerCRUDAGGridModules(
  args: RegisterCRUDAGGridModulesArgs = {}
) {
  if (crudModulesRegistered) {
    const additionalModules = (args.additionalModules || []).filter(
      (module) => {
        return !registeredModules.has(module);
      }
    );

    if (additionalModules.length > 0) {
      ModuleRegistry.registerModules(additionalModules);
      additionalModules.forEach((module) => {
        registeredModules.add(module);
      });
    }

    return;
  }

  const modulesToRegister = [
    ...crudAGGridModules,
    ...(args.additionalModules || []),
  ];

  ModuleRegistry.registerModules(modulesToRegister);
  modulesToRegister.forEach((module) => {
    registeredModules.add(module);
  });

  crudModulesRegistered = true;
}
